<template>
  <b-overlay
    :show="__isOnLoad"
    variant="dark"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%;"
  >
  
    <div class="listeMode" v-for="(item, index) in __list.filter(e=>e.pId === '0')" :key="index">
      <div class="preview">
        <b-icon :icon="getIcon(item.type)" :class="getClass(item.type)"></b-icon>
        {{ item.name }}</div>

      <div class="menu" >
        <ico-btn size='p' type="simple" icone="gear-fill" :cb="()=>{dispatchEdit(item._id)}"></ico-btn>
        <ico-btn size='p' type="warning" icone="trash" :cb="()=>{dispatchDelete(item._id)}"></ico-btn>
        <ico-btn size='p' type="toggleOn" custom="green" icone="plus-circle" :cb="()=>{dispatchAdd(item._id, item.type)}"></ico-btn>
      </div>
      <div style="clear:both"></div>
              <div class="sublisteMode" v-for="(subitem, subindex) in __list.filter(s=>s.pId === item._id)" :key="subindex" :style="">
              <div class="preview">{{ subitem.name }}</div>

              <div class="menu">
                <ico-btn size='p' type="simple" icone="gear-fill" :cb="()=>{dispatchEdit(subitem._id, subitem.pId)}"></ico-btn>
                <ico-btn size='p' type="warning" icone="trash" :cb="()=>{dispatchDelete(subitem._id), subitem.pId}"></ico-btn>
              </div>
            </div>
    </div>

  </b-overlay>
</template>
<script>

export default {
  components: {
  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    __editMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

  },
  
  data() {
    return {
    };
  },
  methods: {
    getIcon(type) {
      switch(type) {
        case 'Shop':
          return 'shop';
        case 'Service':
          return 'tools';
        case 'Carburant':
          return 'speedometer';
        case 'Lubrifiant':
          return 'wrench';
      }
      return 'shop';
    },

    getClass(type) {
      switch(type) {
        case 'Shop':
          return 'shop';
        case 'Service':
          return 'service';
        case 'Carburant':
          return 'carburant';
        case 'Lubrifiant':
          return 'lubrifiant';
      }
      return 'shop';
    },

    dispatchEdit(idx) {
      this.$parent.editAction(idx);
    },

    dispatchAdd(id, pType) {
      this.$parent.addAction(id, pType);
    },

    dispatchDelete(idx) {
      this.$bvModal.msgBoxConfirm('Veuillez confirmer la suppression.', {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Confirmer',
        cancelTitle: 'Annuler',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: false
      })
        .then(value => {
          if(value) {
            this.$parent.deleteAction(idx);
          }
        })
    },
  },
  watch: {
    __isOnLoad: function () {

    },
  },
  computed: {
  },
  mounted() {

  }
};
</script>
<style scoped>
.listeMode {
    width: 100%;
    float: left;
    padding: 1%;
    margin-bottom: 10px;
    border-radius: 10px;
    min-height: 40px;
    background-color: #1b1b29;
}
.listeMode .menu {
    float: right;
    border-radius: 10px;
    background-color: #1b1b29;
}
.listeMode .preview {
    font-weight:bolder;
    float: left;
    font-size: 18px;
}

.sublisteMode {
   
    width: 33%;
    float: left;
    padding: 1%;
    margin-bottom: 10px;
    border-radius: 10px;
    min-height: 40px;
    background-color: #1b1b29;
}
.sublisteMode .menu {
    float: right;
    border-radius: 10px;
    background-color: #1b1b29;
}
.sublisteMode .preview {
    float: left;
    font-weight: lighter;
    font-size:13px
}
.shop{
  color: #2bffc6;
}
.service{
  color: #ff8d72;
}
.lubrifiant{
  color: #ffd600;
}

.carburant{
  color: #b1cf0c
}
</style>